import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/components/WebView/icons/Trashcan.svg'
import _imports_1 from '@/assets/img/Icons/Grey/Plus.svg'


const _withScopeId = n => (_pushScopeId("data-v-5b1217f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-bar-active-container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "del" }, "×", -1))
const _hoisted_5 = {
  key: 0,
  class: "more-filters-note"
}
const _hoisted_6 = { class: "current-filter-title" }
const _hoisted_7 = { class: "icon-trash" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "current-filter-clear" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "save filter", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterModalMobileHeader = _resolveComponent("FilterModalMobileHeader")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_ctx.filterActive && (!_ctx.tsMobileView || _ctx.rules.length > 0))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([
            'filter-bar-active',
            _ctx.tsMobileView
                ? 'filter-bar-active-mobile'
                : 'filter-bar-active-desktop',
        ])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_TransitionGroup, { name: "rules" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rules, (rule, i) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: rule.column + '/' + rule.operator,
                  class: _normalizeClass([
                        'filter-rule',
                        { 'filter-rule-multiple': _ctx.rules.length > 1 },
                    ]),
                  onClick: ($event: any) => (
                        _ctx.removeFilterRule({
                            id: _ctx.filterActive.id,
                            column: rule.column,
                            operator: rule.operator,
                        })
                    )
                }, [
                  _createTextVNode(_toDisplayString(_ctx.formatColumn(rule.column)), 1),
                  (
                            _ctx.shouldDisplayColon(rule.column) && rule.value.length
                        )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, ":"))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.formatLabel(rule.column, rule.value, rule.operator)) + " ", 1),
                  _hoisted_4
                ], 10, _hoisted_2)), [
                  [_vShow, !_ctx.tsMobileView || _ctx.rules.length - 1 == i]
                ])
              }), 128))
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_Dropdown, {
            ref: "dropdown",
            modal: _ctx.tsMobileView
          }, {
            trigger: _withCtx(() => [
              (_ctx.tsMobileView && _ctx.rules.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createTextVNode(" + " + _toDisplayString(_ctx.rules.length - 1) + " more filter", 1),
                    (_ctx.rules.length > 2)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode("s")
                        ], 64))
                      : _createCommentVNode("", true),
                    _createTextVNode("... ")
                  ]))
                : _createCommentVNode("", true)
            ]),
            content: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["options", { 'ts-modal-c': _ctx.tsMobileView }])
              }, [
                (_ctx.tsMobileView)
                  ? (_openBlock(), _createBlock(_component_FilterModalMobileHeader, {
                      key: 0,
                      title: "Edit Filter",
                      onClose: _ctx.closeModal
                    }, null, 8, ["onClose"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["current-filters", {
                                'mobile-view-modal-content-margin':
                                    _ctx.tsMobileView,
                            }])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rules, (rule) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: rule.column + '/' + rule.operator
                    }, [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.formatColumn(rule.column)), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rule.value, (value) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 
                                        rule.column +
                                        '/' +
                                        rule.operator +
                                        '/' +
                                        value
                                    ,
                          class: "current-filter-value"
                        }, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.formatColumn(value)), 1),
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("img", {
                              src: _imports_0,
                              onClick: ($event: any) => (
                                                _ctx.removeFilterValue({
                                                    ruleValue: value,
                                                    id: _ctx.filterActive.id,
                                                    column: rule.column,
                                                })
                                            )
                            }, null, 8, _hoisted_8)
                          ])
                        ]))
                      }), 128))
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (
                                        _ctx.removeAllFilters({
                                            id: _ctx.filterActive.id,
                                        })
                                    ))
                    }, " CLEAR ALL ")
                  ])
                ], 2)
              ], 2)
            ]),
            _: 1
          }, 8, ["modal"]),
          (_ctx.rules && _ctx.rules.length > 0 && !_ctx.tsMobileView)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "filter-save",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.initSaveFilter && _ctx.initSaveFilter(...args)))
              }, _hoisted_13))
            : _createCommentVNode("", true)
        ])
      ], 2))
    : _createCommentVNode("", true)
}